import { ResourceData } from '../../api/airesource.api';
import { AiResourceApi } from '../../api';
import { AIPlaygroundPlatform } from '../../api/aiplayground.objects';

import onboardingResourcesData from '../../resources/LandingPage/landingPageResources.json';
import masspResourcesData from '../../resources/Massp/masspResources.json';
import aiPlaygroundResourcesData from '../../resources/AIPlayground/aiplaygroundResources.json';

/**
 * Service for retrieving AI ecosystem resources information
 */
export class AiResourceService implements AiResourceApi {
  /**
   * Get all onboarding resources
   *
   * @returns An array of all onboarding resources
   */
  getOnboardingResources(): ResourceData[] {
    return onboardingResourcesData.resources;
  }

  /**
   * Get all massp4ai resources
   *
   * @returns An array of all massp4ai resources
   */
  getMassPResources(): ResourceData[] {
    return masspResourcesData.resources;
  }

  /**
   * Get all ai sandbox resources
   *
   * @returns An array of all ai playground resources
   */
  getAiPlaygroundResources(): ResourceData[] {
    return (
      aiPlaygroundResourcesData as { platforms: AIPlaygroundPlatform[] }
    ).platforms.map(platform => ({
      ...platform,
      description:
        typeof platform.tileDescription === 'string'
          ? platform.tileDescription
          : JSON.stringify(platform.tileDescription),
    }));
  }
}

/**
 * Singleton instance of AiResourceService
 */
export const aiResourceService = new AiResourceService();
